module.exports = __webpack_public_path__ + "static/img/Liquid Silicone Rubber for Molding.c2df867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Liquid Silicone Rubber for Molding.jpg
// module id = WXPX
// module chunks = 1